import { render, staticRenderFns } from "./StepsSidebar.vue?vue&type=template&id=04d8961c&scoped=true&lang=html&"
import script from "./StepsSidebar.vue?vue&type=script&lang=js&"
export * from "./StepsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StepsSidebar.vue?vue&type=style&index=0&id=04d8961c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8961c",
  null
  
)

export default component.exports